import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { isOpen } from 'ha/modules/ModalsLogic/selectors';
import { MobileFiltersModalName } from 'ha/constants/Filters';
import MobileMap from '../components/MobileMap';
import { isMobileMapOpen } from '../selectors';
import { toggleMobileMap } from '../actions';

const enhance = connect(
  createStructuredSelector({
    isMobileMapOpen,
    isMobileFiltersOpen: isOpen(MobileFiltersModalName),
  }),
  {
    toggleMobileMap,
  },
);

export default enhance(MobileMap);
